"use strict";
/**
 * @license
 * Copyright 2020 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { RefCounted } from "#src/util/disposable.js";
import { Uint64 } from "#src/util/uint64.js";
import { DependentViewWidget } from "#src/widget/dependent_view_widget.js";
import { Tab } from "#src/widget/tab_view.js";
export class SegmentationGraphSourceTab extends Tab {
  constructor(layer) {
    super();
    this.layer = layer;
    const { element } = this;
    element.appendChild(
      this.registerDisposer(
        new DependentViewWidget(
          layer.displayState.segmentationGroupState.value.graph,
          (graph, parent, context) => {
            if (graph?.tabContents) {
              parent.appendChild(graph.tabContents(layer, context, this));
            }
          }
        )
      ).element
    );
  }
}
export class SegmentationGraphSource {
}
export class SegmentationGraphSourceConnection extends RefCounted {
  constructor(graph, segmentsState) {
    super();
    this.graph = graph;
    this.segmentsState = segmentsState;
  }
  createRenderLayers(chunkManager, displayState, localPosition) {
    chunkManager;
    displayState;
    localPosition;
    return [];
  }
}
export function trackWatchableValueSegment(graph, watchable) {
  let lastId;
  let watchDisposer = void 0;
  const handleLocalChange = () => {
    const { value } = watchable;
    if (value === void 0) {
      if (watchDisposer !== void 0) {
        watchDisposer();
        watchDisposer = void 0;
        lastId = void 0;
      }
      return;
    }
    if (lastId != null && Uint64.equal(lastId, value)) {
      return;
    }
    if (watchDisposer !== void 0) {
      watchDisposer();
      watchDisposer = void 0;
      lastId = void 0;
    }
    watchDisposer = graph.trackSegment(value, (newId) => {
      lastId = newId;
      watchable.value = newId ?? void 0;
    });
  };
  handleLocalChange();
  const signalDisposer = watchable.changed.add(handleLocalChange);
  const disposer = () => {
    signalDisposer();
    if (watchDisposer !== void 0) {
      watchDisposer();
      watchDisposer = void 0;
    }
  };
  return disposer;
}
